module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-75.8cf415bf.svg";